module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/7-9317abd681d33b016786d6092acd63ae.svg";